import { t } from "@/locales/i18n";

interface OAuthError {
  error: string;
  error_description?: string;
  error_uri?: string;
}

export function useOAuthError() {
  function formatError(_error: OAuthError) {
    return t("fallback.oauth.authenticationFailed");
  }

  return {
    formatError,
  };
}
